<template>
    <div class="divPainelNoticias">
        <div class="d-flex p-5 col-12" style="margin-bottom: 20px; justify-content: space-between; align-items:center">
            <div class="d-grid">
                <span style="font-size: 28px; text-align: left; color: #fff">
                    Painel de Novidades!
                </span>
                <span style="text-align: left;  color: #fff">
                    Realize o lançamento e ordenação das notícias!
                </span>
            </div>
            <div>
                <button class="btn btn-success mb-3" @click="abrirModalAdicionar">Adicionar Notícia</button>
            </div>
        </div>

        <draggable v-model="noticias" handle=".handle" class="list-group m-5">
            <div v-for="(noticia, index) in noticias" :key="index"
                class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                    <strong>{{ noticia.titulo_noticia }}</strong>
                </div>
                <div>
                    <button class="btn btn-primary btn-sm mr-2" @click="editarNoticia(index)">Editar</button>
                    <button class="btn btn-danger btn-sm mr-2" @click="editarNoticia(index)">Excluir</button>
                    <span class="handle" style="cursor: move;">⬍</span>
                </div>
            </div>
        </draggable>

        <div class="text-right pr-5">
            <button class="btn btn-success" @click="salvarOrdenacao">Salvar Ordem</button>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="modalNoticia" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modoEdicao ? 'Editar Notícia' : 'Adicionar Notícia' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="text-align: left;">
                        <div class="form-group">
                            <label>Título</label>
                            <input v-model="formulario.titulo_noticia" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Descrição</label>
                            <input v-model="formulario.descricao_noticia" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Texto</label>
                            <vue-editor v-model="formulario.texto_noticia"></vue-editor>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" data-dismiss="modal" @click="fecharModal()">Cancelar</button>
                        <button class="btn btn-primary" @click="salvarNoticia">Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import draggable from "vuedraggable";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    draggable,
    VueEditor,
  },
  data() {
    return {
      noticias: [],
      formulario: {
        titulo_noticia: '',
        descricao_noticia: '',
        texto_noticia: ''
      },
      indexEditando: null,
      modoEdicao: false
    };
  },
  mounted() {
    this.buscarNoticias();

    const user = this.$store.getters['busca/filial']

    if(!user.infColab.email.includes('@i9ss.com.br')){
      window.location = '/bi/inicio'
    }
  },
  methods: {
    buscarNoticias() {
        this.$store.dispatch('busca/getNoticias').then(response => {
            this.noticias = response.data
        })
    //   // Simulando retorno do backend
    //   this.noticias = [
    //     {
    //       titulo: 'Noticia 01',
    //       descricao: 'Esta e a noticia 01',
    //       texto: '<h1>Este sera o conteudo principal da noticia</h1>'
    //     },
    //     {
    //       titulo: 'Noticia 02',
    //       descricao: 'Esta e a noticia 02',
    //       texto: '<h1>Este sera o conteudo principal da noticia</h1>'
    //     }
    //   ];
    },
    fecharModal(){
         $('#modalNoticia').modal('hide');
    },
    abrirModalAdicionar() {
    //   this.resetFormulario();
      this.modoEdicao = false;
      $('#modalNoticia').modal('show');
    },
    editarNoticia(index) {
      this.indexEditando = index;
      this.formulario = { ...this.noticias[index] };
      this.modoEdicao = true;
      $('#modalNoticia').modal('show');
    },
    salvarNoticia() {
      if (this.modoEdicao) {
        this.$store.dispatch('busca/updateNoticia', { data: this.formulario })

        this.$set(this.noticias, this.indexEditando, { ...this.formulario });
      } else {
        // this.noticias.push({ ...this.formulario });
        this.$store.dispatch('busca/salvarNoticia', {data: this.formulario}).then(response => {
            this.$swal.fire({
                title: 'Sucesso!',
                text: 'Noticia cadastrada com sucesso!',
                icon: 'success'
            })
        })
        this.buscarNoticias()
      }
      $('#modalNoticia').modal('hide');
    },
    excluirNoticia(){
        this.$swal.fire({
            title: 'Excluir registro',
            text: 'Deseja excluir a notícia?',
            icon: 'warning'
        })
    },
    resetFormulario() {
      this.formulario = {
        titulo: '',
        descricao: '',
        texto: ''
      };
      this.indexEditando = null;
    },
    salvarOrdenacao() {
      // Aqui você pode enviar a nova ordem pro backend
      console.log("Nova ordem:", this.noticias);
      const data = {
        noticias: this.noticias
      }
      this.$store.dispatch('busca/updateOrdemNoticias', { data: data })
    }
  }
};
</script>

<style>
    .handle {
        font-size: 1.2rem;
    }

    .divPainelNoticias {
        background-color: #303038;
        height: 100vh !important;
    }
</style>
